<template>
  <div :class="isApp == true ? '' : 'content'">
    <Header></Header>
    <div class="main" v-show="isApp == true ? false : true">
      <!-- <div class="main_left">
        <div class="index-buygift">
          <img src="../assets/index/btn-buygift-top.gif" alt="" />
          <a class="btn-buygift buy" href="">
            <img v-show="isbuyIconEn" src="../assets/index/buy_en.png" alt="" />
            <img v-show="isbuyIconZh" src="../assets/index/buy_zh.png" alt="" />
          </a>
        </div>
        <div class="index-transfer">
          <img src="../assets/index/btn-transfer-top.gif" alt="" />
          <a class="btn-transfer" href="">
            <img
              v-show="isbuyIconEn"
              src="../assets/index/gift_en.png"
              alt=""
            />
            <img
              v-show="isbuyIconZh"
              src="../assets/index/gift_zh.png"
              alt=""
            />
          </a>
        </div>

        <div class="side-info-wrap">
          <div class="side-info-gradient">
            <div class="dw-motion">
              <img src="../assets/index/yao.gif" alt="" />
            </div>
           <div class="xiazai">
              <div class="xia_left">
                <div class="">
                  <a href="https://dl.tiger777.com/" target="_blank" class="xia_left_top">
                    <img
                      src="../assets/index/qrcode-ios.png"
                    />
                  </a>
                  <a href="https://dl.tiger777.com/" target="_blank"
                    ><div class="dianji">
                      {{ $t("index.xiaZai")
                      }}<i class="el-icon-caret-right"></i></div
                  ></a>
                  <a href="https://dl.tiger777.com/" target="_blank" class="xia_left_center">
                    <img src="../assets/index/ma.png" alt="" />
                  </a>
                  <a href="https://dl.tiger777.com/" target="_blank" class="xia_left_btm">
                    <img src="../assets/index/ma2.png" alt="" />
                  </a>
                </div>
              </div>
              <div class="xia_right">
                <div class="">
                  <a href="https://dl.tiger777.com/" target="_blank" class="xia_left_top">
                    <img
                      src="../assets/index/qrcode-akp.png"
                    />
                  </a>
                  <a href="https://dl.tiger777.com/" target="_blank">
                    <div class="dianji">
                      {{ $t("index.xiaZai")
                      }}<i class="el-icon-caret-right"></i>
                    </div>
                  </a>
                  <a href="https://dl.tiger777.com/" target="_blank" class="xia_left_center"
                    ><img src="../assets/index/apk.png" alt=""
                  /></a>
                </div>
              </div>
            </div>

            <div class="fbBtn_wrap" style="padding:0.2rem">
              <a href="https://t.me/Tiger777com" target="_blank">
                  <img src="../assets/index/liaotian.png" style="width:9.375rem;height:3.125rem" alt="">
                </a>
            </div>
          </div>
        </div>
      </div> -->
      <MainLeft></MainLeft>
      <div class="main_content">
        <div class="zanwie"></div>
        <div class="news">
          <div class="new_title">
               <div @click="goBack" class="goback"><img src="../assets/index/goback.png" alt=""></div>
                <div>{{newContent}}</div>     
          </div>
          <div class="newDetails" v-html="newDetails">
          </div>
        </div>
      </div>
    </div>
    <div class="isapp" v-show="isApp == false ? false : true">
      <div class="zanwie"></div>
        <div class="isapp_news">
          <div class="new_title">
               <div @click="goBack" class="goback"><img src="../assets/index/goback.png" alt=""></div>
                <div class="isapp_newContent">{{newContent}}</div>     
          </div>
          <div class="newDetails" v-html="newDetails">
             
          </div>
        </div>
    </div>
    <Footer></Footer>
    <Login-pop ref="LoginPop"></Login-pop>
    <router-view></router-view>
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from "vuex";
import "../assets/h5/h5dex.css";
export default {
  data() {
    return {
      currentPage: 1,  // 当前页码
      pageSize: 2,  // 每页显示的行数
      listsDataNumber:'',
      isbuyIconEn: true,
      isbuyIconZh: false,
      active: 0,
      newDetails: '',
      newContent:''
    };
  },
  created() {
    this.showAll();
    this.changeIcon();
  },
  computed: {
    //获取STORE里isApp
    ...mapState({
      isApp(state) {
        return state.isApp;
      },
       hasLogin(state) {
        return state.hasLogin;
      },
    }),
  },
  mounted() {
    this.changeIcon();
  },
  methods: {
       
    showAll() {
      this.newDetails=this.$route.params.details
      this.newContent=this.$route.params.content
    },
    changeIcon() {
      let lang = localStorage.getItem("lang");
      if (lang == "en") {
        this.isbuyIconEn = true;
        this.isbuyIconZh = false;
      }
      if (lang == "zh") {
        this.isbuyIconEn = false;
        this.isbuyIconZh = true;
      }
    },
    goBack(){
        this.$router.back();
    }
  },
};
</script>
<style lang="less" scoped="">
p{
  color: black;
}
.content {
  width: 100%;
  background: #ad0000 url("../assets/index/bg-pc-head.jpg") center top no-repeat;
  background-size: 100% auto;
}
.main_content {
  width: 75%;
  float: right;
}
.zanwie {
  height: 1.25rem;
}
.el-carousel {
  border: 0.0625rem solid rgb(209, 160, 38);
  background-color: rgb(209, 160, 38);
  padding: 0.125rem 0;
  border-bottom-left-radius: 0.625rem;
  border-bottom-right-radius: 0.625rem;
}
.el-carousel__item {
  // margin-top: 1.25rem;
}
.el-carousel__item img {
  color: #475669;
  line-height: 22.5rem;
  width: 55.5rem;
  height: 21.875rem;
}
.news {
  width: 55.5rem;
  // height: 29.375rem;
  background-color: rgb(226, 196, 33);
  border-radius: 0.625rem;
  position: relative;
}
.new_title {
  height: 3rem;
  font-size: 2rem;
  line-height: 3rem;
  color: black;
  position: relative;
}
.news_list {
  display: flex;
  flex-direction: row;
  width: 54.6875rem;
  border: 0.0625rem solid #e25b2a;
  border-radius: 0.3125rem;
  margin: 0 auto;
}
.news_list_title {
  width: 25%;
}
.newColorAA {
}
.colorBlack {
  color: red;
}
.colorWhite {
  color: aliceblue;
}
.itemSub {
  // position: absolute;
  display: flex;
  flex-direction: row;
  text-align: center;
  border-bottom: 0.0625rem solid rgb(202, 202, 202);
  border-left: 0.0625rem solid rgb(137, 137, 137);
  border-right: 0.0625rem solid rgb(137, 137, 137);

  width: 54.6875rem;
  margin: 0 auto;
  height: 3.125rem;
  line-height: 3.125rem;
  background: rgb(202, 202, 202);
}
.itemSub_type {
  padding-left: 1.25rem;
  // background-color:rgb(7, 96, 172);
}
.itemSub_type_sub {
  background-color: rgb(7, 96, 172);
  height: 1.875rem;
  padding: 0 0.3125rem;
  line-height: 1.875rem;
  margin-top: 0.625rem;
  color: aliceblue;
  border-radius: 0.3125rem;
  // font-size: 1.25rem;
}
.itemSub_time {
  padding-left: 1.25rem;
  color: red;
  font-weight: 600;
  font-size: 1.25rem;
}
.itemSub_content {
  padding-left: 1.25rem;
  font-size: 1.25rem;
  color: black;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.more {
  width: 54.6875rem;
  margin: 0 auto;
  line-height: 2.5rem;
  bottom: 0;
  left: 45%;
  height: 2.5rem;
  border-top: none;
  border-left: 0.125rem solid rgba(0, 0, 0, 0.514);
  border-right: 0.125rem solid rgba(0, 0, 0, 0.514);
  border-bottom: 0.125rem solid rgba(0, 0, 0, 0.514);
  color: black;
  font-size: 1.5625rem;
}
.more_look {
  align-items: center;
  background-image: linear-gradient(0deg, #d8cc0f, #e6ac29);
  display: flex;
  justify-content: center;
  .more_look span {
    display: block;
  }
  .el-icon-caret-right {
    font-size: 1.875rem;
    // margin-top: 0.625rem;
  }
}
.zanwei_sub {
  width: 55.5rem;
  height: 18.75rem;
  overflow-x: hidden;
  margin: 0 auto;
  background-color: #e2c421;
  padding-bottom: 0.625rem;
}
.carousel {
  // width: 23.4375rem;
  //   height: 12.5rem;
}
.isapp_carousel_img{
width: 100%;
}
/deep/ .el-carousel{
  z-index: 0;
}
.isnews{
    background-color: rgb(226, 196, 33);
    border-radius: 0.625rem;
    position: relative;
}
.newDetails{
    background: rgb(226, 226, 226);
    padding: 0.625rem;
    min-height: 15.625rem;
}
.newDetails p{
  color: black;
}
.goback{
    position: absolute;
    text-align: left;
    top: 0.125rem;
    left: 0.625rem;
}
.goback img{
    width: 3.125rem;
    height: 1.875rem;
}
.isapp_news{
    background-color: #e2c421;
    border-radius: 0.625rem;
    position: relative;
    padding-bottom: 0.6rem;
}
.isapp_newContent{
    font-size: 1.25rem;
}
</style>
